import moment from "moment"
import Event from "src/components/Calendar/Event"
import { DEFAULT_EVENT_OPACITY } from "../constants"

const DEFAULT_BACKGROUND_COLOR = `#d9d9d9`
const DEFAULT_TEXT_COLOR = `#000000`

export const isTooBright = (hex, opacity) => {
  const c = hex.substring(1) // strip #
  const rgb = parseInt(c, 16) // convert rrggbb to decimal
  // eslint-disable-next-line
  const r = (rgb >> 16) & 0xff // extract red
  // eslint-disable-next-line
  const g = (rgb >> 8) & 0xff // extract green
  // eslint-disable-next-line
  const b = (rgb >> 0) & 0xff // extract blue

  if (opacity < 0.3) {
    return true
  }

  return r * 0.299 + g * 0.587 + b * 0.114 > 186
}

export const makeTransparent = (hex, opacity) => {
  const c = hex.substring(1) // strip #
  const rgb = parseInt(c, 16) // convert rrggbb to decimal
  // eslint-disable-next-line
  const r = (rgb >> 16) & 0xff // extract red
  // eslint-disable-next-line
  const g = (rgb >> 8) & 0xff // extract green
  // eslint-disable-next-line
  const b = (rgb >> 0) & 0xff // extract blue

  return `rgba(${r}, ${g}, ${b}, ${opacity})`
}
export const DEFAULT_COLOR = makeTransparent(`#44bcf5`, 0.4)

export default function eventToItem(event, resource, inPlan) {
  const color = event.eventTypeColor
  const style = {
    background: makeTransparent(
      color || DEFAULT_BACKGROUND_COLOR,
      DEFAULT_EVENT_OPACITY,
    ),
    color: isTooBright(color || DEFAULT_TEXT_COLOR, 0.6)
      ? `rgba(0, 0, 0, 0.8)`
      : `#fff`,
  }

  return {
    isPlan: inPlan,
    id: `${resource.uuid}_${event.uuid}`,
    originId: event.uuid,
    name: event.name,
    title: event.eventTypeName || event.eventTypeId,
    start_time: moment(event.startDateTime),
    count: event.count || 0,
    originalStartTime: moment(event.startDateTime),
    end_time: moment(event.endDateTime),
    originalEndTime: moment(event.endDateTime),
    description: !event.eventsStack ? event.description : event.count,
    planInfo: event.planInfo,
    resourceFields: resource.resourceTypeFields,
    resourceUuid: resource.uuid,
    onlyDate: event.eventTypeAllowOnlyDate,
    type: event.eventTypeName,
    typeId: event.eventTypeId,
    color,
    style,
    itemTouchSendsClick: true,
    Component: Event,
    startDateTime: event.startDateTime,
    original: event,
    status: event.status,
    restrictions: event.restrictions,
  }
}
